// extracted by mini-css-extract-plugin
export default {"wrapper":"b2-z","play":"c2-z"};